// @flow

import updateEstimateGroupName from '../../../Services/updateEstimateGroupName';
import type { UpdateEstimateGroupNameParams } from '../../../types';

export default (params: UpdateEstimateGroupNameParams) => async (dispatch: Function) => dispatch(updateEstimateGroupName(params));